/* eslint-disable no-extra-parens */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

interface HurricanePageMapLegendProps {
    legendColours: string[];
    legendLabels: string[];
    isHUrricaneWidgetMap: boolean;
}

export const HurricanePageMapLegend = ({ legendColours, legendLabels, isHUrricaneWidgetMap }: HurricanePageMapLegendProps) => {
    if (isHUrricaneWidgetMap || (!legendColours?.length && !legendLabels?.length && legendColours?.length === legendLabels?.length)) {
        return null;
    }

    return (
        <LegendContainer numberOfGridColumns={legendColours.length}>
            {
                legendColours?.map((legendColour, index) => {
                    const legendLabel = legendLabels[index];
                    return <LegendItem legendColour={legendColour} key={legendColour}>{legendLabel}</LegendItem>;
                })
            }
        </LegendContainer>
    );
};

interface LegendContainerProps {
    numberOfGridColumns: number;
}
const LegendContainer = styled.div<LegendContainerProps>`
    display: grid;
    grid-template-columns: ${({ numberOfGridColumns }) => numberOfGridColumns 
        ? `repeat(${numberOfGridColumns}, minmax(42.86px, 1fr))` 
        : 'repeat(7, minmax(42.86px, 1fr))'};
    width: 100%;
    height: 16px;
    position: absolute;
    left: 0;
`;

interface LegendItemProps {
    legendColour: string;
}
const LegendItem = styled.span<LegendItemProps>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 100%;
    height: 100%;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    color: #111111;
    background-color: ${({ legendColour }) => legendColour ? legendColour : ''};
`;